import SecureStorage, { AuthService } from "../utils/secureStorage";
import {
  forgetAddressSecrets,
  searchWithSecrets,
} from "../utils/addressSecrets";

export const IMPERSONATION_PARAM = "imp";

export async function exchangeImpersonationHandoff(
  oneTimeId: string
): Promise<AuthService | null> {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_UMD_BACK_END_DOMAIN}/impersonation/exchange`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ one_time_id: oneTimeId }),
      }
    );
    if (!res.ok) {
      return null;
    }
    const json = await res.json();
    const blob = json?.data ?? json?.element ?? null;
    if (!blob?.access_token || !blob?.user_identification) {
      return null;
    }
    return blob as AuthService;
  } catch {
    return null;
  }
}

export function readImpersonationParam(): string | null {
  try {
    return searchWithSecrets(
      window.location.pathname,
      window.location.search
    ).get(IMPERSONATION_PARAM);
  } catch {
    return null;
  }
}

export function stripImpersonationParam(): void {
  try {
    forgetAddressSecrets(window.location.pathname, [IMPERSONATION_PARAM]);
    const url = new URL(window.location.href);
    url.searchParams.delete(IMPERSONATION_PARAM);
    window.history.replaceState(
      {},
      document.title,
      url.pathname + url.search + url.hash
    );
  } catch {}
}

export async function bootstrapImpersonationFromUrl(): Promise<AuthService | null> {
  const oneTimeId = readImpersonationParam();
  if (!oneTimeId) {
    return null;
  }
  const blob = await exchangeImpersonationHandoff(oneTimeId);
  stripImpersonationParam();
  if (blob) {
    const exp =
      blob.impersonation_expires_at != null
        ? new Date(blob.impersonation_expires_at)
        : new Date(Date.now() + 30 * 60 * 1000);
    SecureStorage.setImpersonationSession({ ...blob, exp });
  }
  return blob;
}
